import { OriginalCalendarObject } from "../services/common"

export enum DayStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  STRIKED = "STRIKED",
}

export interface NewDayObject extends OriginalCalendarObject {
  isDisabled: boolean
  maximumBookingDuration: number
  msg?: string[]
  status: DayStatus
  bookedDates?: boolean
}

const AvailibitlityOfDates = (
  originalDates: NewDayObject[],
  shouldCheckArrivalDeparture: boolean,
  shouldMaximizeProfit: boolean,
  selectedDate: string | null,
  isReccurent = false,
): NewDayObject[] => {
  let clone: NewDayObject[] = []
  if (!isReccurent) {
    clone = [...originalDates]
  } else {
    clone = originalDates.map((x: NewDayObject) => ({
      ...x,
      isDisabled: false,
      msg: [] as string[],
    }))
  }

  const selectedDateIndex = originalDates.findIndex(
    (x) => x.valid_from.trim() === selectedDate,
  )

  if (selectedDateIndex > -1) {
    // meaning initial date is given

    // if inital date is selected Then strike-out all past dates
    for (let i = 0; i < selectedDateIndex; i += 1) {
      clone[i].isDisabled = true
      clone[i].status = DayStatus.STRIKED
      // clone[i].msg = ["Past Date"]
    }
    clone[selectedDateIndex].isDisabled = true
    clone[selectedDateIndex].status = DayStatus.DISABLED

    // if inital date is selected Then disable next minStay no. of dates
    for (
      let i = 1;
      i < clone[selectedDateIndex].min_nights &&
      selectedDateIndex + i < clone.length;
      i += 1
    ) {
      clone[selectedDateIndex + i].isDisabled = true
      clone[selectedDateIndex + i].status = DayStatus.DISABLED
      clone[selectedDateIndex + i].msg = [
        `${clone[selectedDateIndex].min_nights}-night-minimum`,
      ]
    }

    // if inital date is selected Then disable all the dates after max_nights
    for (
      let i = selectedDateIndex + clone[selectedDateIndex].max_nights + 1;
      i < clone.length;
      i += 1
    ) {
      clone[i].isDisabled = true
      clone[i].status = DayStatus.STRIKED
      // clone[i].msg = [`${clone[selectedDateIndex].max_nights}-night-maximum`]
    }

    // if inital date is selected Then disable all the dates after first booked day reached
    let nextFirstBookedDateIndex = selectedDateIndex
    for (let i = selectedDateIndex; i < clone.length; i += 1) {
      if (clone[i].available === false) {
        nextFirstBookedDateIndex = i
        break
      }
    }
    if (selectedDateIndex !== nextFirstBookedDateIndex) {
      for (let i = nextFirstBookedDateIndex + 1; i < clone.length; i += 1) {
        clone[i].isDisabled = true
        clone[i].status = DayStatus.STRIKED
        // clone[i].msg?.push(`In between date(s) are already booked`)
      }
    }

    if (shouldCheckArrivalDeparture) {
      // disable all non-departure dates
      for (let i = 0; i < clone.length; i += 1) {
        if (clone[i].isDisabled) continue // Early exit.

        const prev = clone[i].isDisabled
        clone[i].isDisabled = !clone[i].departure || clone[i].isDisabled
        if (prev !== clone[i].isDisabled && clone[i].isDisabled) {
          clone[i].status = DayStatus.DISABLED
          clone[i].msg?.push(`Checkout not allowed`)
        }
      }
    }

    // feature of maximizing stay for host
    // where if 14 hase 3 minstay and 15 has 6 minstay in that case 14 also must have 6 minstay
    if (shouldMaximizeProfit) {
      let newMaxStay = 0
      // let biggestMessageMinstay = 0
      for (let i = selectedDateIndex + 1; i < clone.length; i += 1) {
        newMaxStay = Math.max(newMaxStay, clone[i - 1].min_nights)
        if (i - selectedDateIndex < newMaxStay) {
          clone[i].isDisabled = true
          clone[i].status = DayStatus.DISABLED
          clone[i].msg = [`${newMaxStay}-night-minimum`]
          // biggestMessageMinstay = newMaxStay
        }
      }

      // for (
      //   let i = 0;
      //   i < biggestMessageMinstay && selectedDateIndex + i < clone.length;
      //   i++
      // ) {
      //   if (clone[selectedDateIndex + i].isDisabled) {
      //     // clone[selectedDateIndex + i].msg = [
      //     //   `${biggestMessageMinstay}-night-minimum`,
      //     // ]
      //   }
      // }
    }

    // this is special case:
    /**
     * If the check-in date is on weekends [weekly_arrival is true], the stay can only be booked for 1/2/3/4/5/6/7/14/21/28... days while satisfying all the min_stays and maxprofit conditions.
     */
    if (clone[selectedDateIndex].weekly_arrival === true) {
      for (let i = selectedDateIndex + 7; i < clone.length; i++) {
        if (clone[i].isDisabled) continue // Early exit.

        if ((i - selectedDateIndex) % 7 == 0) {
          // next saturdays if selected date is saturday
        } else {
          // other than saturdays if selected day is saturday
          clone[i].isDisabled = true
          clone[i].status = DayStatus.DISABLED
          // clone[i].msg = ["non-weekend day"]
        }

        if (clone[i].available === false) {
          // no need to go all the way to end
          break
        }
      }
    }
  } else {
    // meaning initial date is not given
    // user trying to select first date

    // it will disabled all dates which can not be rented and the days in betweens are already rented
    // if 17 has minStay as 3, and if 18 or 19 are already booked, 17 will get disabled
    for (let i = 0; i < clone.length; i += 1) {
      const minDays = clone[i].min_nights
      if (minDays > clone[i].maximumBookingDuration) {
        clone[i].isDisabled = true
        clone[i].status = DayStatus.DISABLED
        clone[i].msg = [`${minDays}-night-minimum`]
      }
    }

    if (shouldCheckArrivalDeparture) {
      // it will disabled all dates which can not be rented because it does not have proper departure date after minDays
      // if 14 has minStay as 2, and 15 and 16 are already available, 17 is booked, 16 and 17 are NON_DEPARTURE then 14 must be disable
      for (let i = 0; i < clone.length; i += 1) {
        if (clone[i].isDisabled) continue // Early exit.

        let minDays = clone[i].min_nights
        if (shouldMaximizeProfit) {
          // in this profit maximization case new minStay will be maximum of its range
          let newMaxStay = minDays
          for (let k = i + 1; k < clone.length; k++) {
            if (clone[k].maximumBookingDuration < clone[k].min_nights) break // stop when we can not book, and minStay will not update
            newMaxStay = Math.max(newMaxStay, clone[k].min_nights)
          }
          minDays = newMaxStay
        }

        // Initially, assuming we don't have slot.
        let isAvailableDepatureSlot = false

        for (
          let j = minDays;
          i + j < clone.length && // making sure it is within range
          j <= clone[i].max_nights;
          j++
        ) {
          if (j != minDays && clone[i + j].available === false) {
            // It means ((i+j)th day) is booked, no need to check next dates.

            /**
             * But just check this date,
             * even though current date (e.g. i+j ) is booked,
             * check if it is okay to departure in the morning.
             * If morning departure available we can book upto this day.
             */
            if (clone[i + j].departure === true) {
              // Now we found the slot.
              isAvailableDepatureSlot = true
            }
            break
          }

          /**
           * If departure available we can book upto this day.
           * No need to check further,
           * as we already found one possible pair of bookable date
           */
          if (clone[i + j].departure === true) {
            // Now we found the slot.
            isAvailableDepatureSlot = true
            break
          }
        }

        if (!isAvailableDepatureSlot) {
          // Disable date if that date does not have slot from minStays to maxStays range.
          clone[i].isDisabled = true
          clone[i].status = DayStatus.DISABLED
          // clone[i].msg = [`No checkout available after minStay`]
        }
      }
    }

    // it will work when inital date is not given
    if (shouldCheckArrivalDeparture) {
      // disable all non-arrivalble dates
      for (let i = 0; i < clone.length; i += 1) {
        if (clone[i].isDisabled) continue // Early exit.
        const prev = clone[i].isDisabled
        clone[i].isDisabled = !clone[i].arrival || clone[i].isDisabled
        if (prev !== clone[i].isDisabled && clone[i].isDisabled) {
          clone[i].status = DayStatus.DISABLED
          clone[i].msg = ["Arrival not allowed"]
        }
      }
    }

    // feature of maximizing stay for host
    // if after selecting x day, if there doesn't exist valid departure date in that case x must be disabled in first place
    if (shouldMaximizeProfit) {
      for (let i = 0 + 1; i < clone.length; i += 1) {
        if (clone[i].isDisabled) continue // Early exit.

        const noOfDeparturableDates = AvailibitlityOfDates(
          originalDates,
          shouldCheckArrivalDeparture,
          shouldMaximizeProfit,
          clone[i].valid_from.trim(), // assuming current date is selected
          true,
        ).reduce((a, c) => (c.isDisabled ? a : a + 1), 0)
        if (noOfDeparturableDates === 0 && clone[i].min_nights > 1) {
          clone[i].isDisabled = true
          clone[i].status = DayStatus.DISABLED
          // clone[i].msg = ["To maximize profit"]
        }
      }
    }

    if (!isReccurent) {
      // const checkingIfItIsSelectable = AvailibitlityOfDates(
      //   originalDates,
      //   isToCheckArrival,
      //   shouldMaximizeProfit,
      //   null,
      //   true,
      // )
      // booked date should be STRIKED OUT unless it is ok to depart on that day
      for (let i = 0; i < clone.length; i += 1) {
        if (!clone[i].available) {
          clone[i].isDisabled = true
          clone[i].status = DayStatus.STRIKED
          clone[i].msg = [] //["Booked"]
        }
        // if (clone[i].isAvailable) continue
        // if (i - 1 >= 0 && !clone[i - 1].isAvailable) {
        //   // means previous day is booked
        //   // so strike out this which already done so don't let following loop part to run
        //   continue
        // }
        // for (let j = i - 1; j >= 0; j--) {
        //   if (checkingIfItIsSelectable[j].isDisabled) {
        //     //means can dates not available to select as first date
        //   } else {
        //     //means date can be selected as first date
        //     const newDates = AvailibitlityOfDates(
        //       originalDates,
        //       isToCheckArrival,
        //       shouldMaximizeProfit,
        //       clone[j].date.trim(),
        //       true,
        //     )
        //     if (newDates[i].isDisabled) {
        //       //means can not departure due to minstay or any such reason
        //       // so check previous
        //     } else {
        //       //means departure is availabe on i th day, so show it in disabled mode instead of stiked out
        //       clone[i].isDisabled = true
        //       clone[i].status = DayStatus.DISABLED
        //       clone[i].msg = ["Checkout only"]
        //     }
        //   }
        // }

        // Alternative way non-recursive
        // if previous day is Available then this day might be used as end date and that's why we can show it as DISABLED instead of STRIKED
        if (
          i - 1 >= 0 &&
          clone[i - 1].available &&
          clone[i].status === DayStatus.STRIKED
        ) {
          // means previous day is available
          // so just DISABLE this
          clone[i].isDisabled = true
          clone[i].status = DayStatus.DISABLED
          clone[i].msg = ["Checkout only"]
        }
        // Alternative way ends
      }
    }

    // if 14 15 16 are booked ("Striked") and 17 18 are disabled because minimin stays are not available, then 17 18 also should be strikedout as there is not meaning of showing it in Disabled, as it can not be selected as first nor as last date.
    // for if previous date is STRIKED AND Current date is Diabled then : CUrrent date should also be STRIKED
    for (let i = 0; i < clone.length; i += 1) {
      if (
        ((i - 1 >= 0 && clone[i - 1].status === DayStatus.STRIKED) || i == 0) && // i==0 is case when first date is disabled in given array, and no previous date is given then the disabled first date should also be Striked
        clone[i].status === DayStatus.DISABLED
      ) {
        clone[i].status = DayStatus.STRIKED
        clone[i].msg = []
      }
    }
  }

  return clone.map((x) => ({
    ...x,
    status: x.status,
  }))
}

export const howManyDaysItCanBeBookedFor = (
  calendar: OriginalCalendarObject[],
  indexOfDate: number,
  options: {
    shouldCheckArrivalDeparture: boolean
  },
) => {
  let ans = 0
  if (!calendar[indexOfDate] || !calendar[indexOfDate]?.available) {
    return 0
  }
  if (options.shouldCheckArrivalDeparture) {
    if (calendar[indexOfDate]?.arrival === false) {
      return 0 //as it can not be booked
    }
    for (
      let i = indexOfDate + 1;
      i < calendar.length &&
      i <= indexOfDate + calendar[indexOfDate].max_nights;
      i++
    ) {
      if (calendar[i].available) {
        ans++
      } else {
        if (calendar[i].departure === true) {
          //means even though it is booked, we can leave in morning as departure is true
          ans++
          return ans
        } else {
          // if departure is not allowed today then we need to go backward to find a date which is available to depart
          for (let j = i - 1; j > indexOfDate; j--) {
            if (calendar[j].departure === true) {
              return ans
            } else {
              ans--
            }
          }
          return 0
        }
      }
    }
  } else {
    for (let i = indexOfDate + 1; i < calendar.length; i++) {
      if (calendar[i].available) {
        ans++
      } else {
        ans++ // because if 15th Date is booked, user can book upto 15 and can leave in the morning of 15
        break
      }
    }
  }

  return ans
}

export const UpdateAvailibitlityOfDates = (
  originalDates: OriginalCalendarObject[],
  shouldCheckArrivalDeparture: boolean,
  shouldMaximizeProfit: boolean,
  selectedDate: string | null,
  isReccurent = false,
): NewDayObject[] => {
  const deeepClone = originalDates.map((item) => {
    return {
      valid_from: item.valid_from,
      min_nights: item.min_nights,
      max_nights: item.max_nights || 365,
      base_price: item.base_price,
      available:
        item.whimstay_availability &&
        item.available &&
        item.base_price &&
        item.base_price > 0
          ? true
          : false,
      arrival: item.arrival,
      departure: item.departure,
      weekly_arrival: item.weekly_arrival,
    }
  })

  const annotatedMaxBookingDurationCalendar = deeepClone.map((date, i) => ({
    ...date,
    maximumBookingDuration: howManyDaysItCanBeBookedFor(deeepClone, i, {
      shouldCheckArrivalDeparture: shouldCheckArrivalDeparture,
    }),
    isDisabled: false,
    msg: [] as string[],
    status: DayStatus.ENABLED,
  }))

  return AvailibitlityOfDates(
    annotatedMaxBookingDurationCalendar,
    shouldCheckArrivalDeparture,
    shouldMaximizeProfit,
    selectedDate,
    isReccurent,
  )
}
